import { all, takeEvery, put, call } from 'redux-saga/effects'
import { history } from 'index'
import {
  Auth_login,
  Auth_currentAccount,
  Auth_logout,
  Auth_invalidate,
  Verify_OTP,
} from 'services/auth'
import Scopes from 'services/scope'
import Common from 'services/common'
import actions from './actions'
import getMenuData from 'services/menu'
import { createHashHistory } from 'history'

function* AfterLoginPrequisites(payload, success) {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  var accRole = '',
    data = success.data.data
  var name = data.name
  // var numclusters = data.access.length
  const { emailId } = payload
  var Access = 'No Access'
  var i = 0,
    j = 0,
    k = 0
  const getAccData = yield call(
    Scopes.getUserAccessDetails,
    success.data.data.SSID,
    success.data.data.SSID,
  )
  if (getAccData) {
    yield put({
      type: 'accdetails/SET_ACCDETAILS',
      payload: getAccData.data.data,
    })
    var SelectedScope =
      getAccData.data.data.access[0]['scope_access'].length > 0
        ? getAccData.data.data.access[0]['scope_access'][0]
        : {}
    var SelectedCluster = getAccData.data.data.access[0]
  }
  var enabledScopelist = getAccData.data.data
  var accClusterCount = 0
  for (let i = 0; i < getAccData.data.data.access.length; i++) {
    if (getAccData.data.data.isAdmin) {
      SelectedCluster = getAccData.data.data.access[i]
      break
    } else {
      var selectClus = {}
      for (let j = 0; j < getAccData.data.data.access[i].scope_access.length; j++) {
        if (getAccData.data.data.access[i].access_type === 'Custom') {
          if (getAccData.data.data.access[i].scope_access[j].role !== 'No Access') {
            selectClus = getAccData.data.data.access[i]
            break
          }
        } else {
          selectClus = getAccData.data.data.access[i]
          break
        }
      }
      if (Object.keys(selectClus).length > 0) {
        SelectedCluster = selectClus
        break
      }
    }
  }
  if (!enabledScopelist.isAdmin) {
    if (SelectedCluster.scope_access.length > 0) {
      if (SelectedCluster.access_type !== 'No Access') {
        for (let j = 0; j < SelectedCluster.scope_access.length > 0; j++) {
          if (SelectedCluster.access_type !== 'No Access') {
            if (SelectedCluster.access_type === 'Administrator') {
              accRole = 'User - SecAdmin Security Engineer'
              // accRole = 'User - SecAdmin ' + SelectedCluster.scope_access[j]['role']
            } else {
              accRole = 'User - ' + SelectedCluster.scope_access[j]['role']
            }
            SelectedScope = SelectedCluster.scope_access[j]
            Access = accRole
            break
          } else if (SelectedCluster['scope_access'][j]['role'] !== 'No Access') {
            if (SelectedCluster.access_type === 'Administrator') {
              accRole = 'User - SecAdmin Security Engineer'
            } else {
              accRole = 'User - ' + SelectedCluster.access_type
            }
            SelectedScope = SelectedCluster.scope_access[j]
            Access = accRole
            break
          } else {
            accRole = 'User - No Access'
          }
        }
      }
    } else {
      if (
        SelectedCluster.scope_access.length === 0 &&
        accRole === '' &&
        SelectedCluster.access_type !== 'Custom'
      ) {
        accRole = 'User - No Access'
      } else {
        if (SelectedCluster.access_type === 'Custom' && SelectedCluster.scope_access.length === 0) {
          accRole = 'User - No Access'
        }
      }
    }
  } else {
    if (SelectedCluster.scope_access.length > 0) {
      for (let j = 0; j < SelectedCluster.scope_access.length > 0; j++) {
        if (SelectedCluster.access_type !== 'No Access') {
          if (
            SelectedCluster.access_type === 'Custom' &&
            SelectedCluster['scope_access'][j]['role'] !== 'No Access'
          ) {
            accRole = 'Admin - ' + SelectedCluster.scope_access[j]['role']
            SelectedScope = SelectedCluster.scope_access[j]
            Access = accRole
            break
          } else if (SelectedCluster['scope_access'][j]['role'] !== 'No Access') {
            if (SelectedCluster.access_type === 'Administrator') {
              accRole = 'Admin - SecAdmin ' + SelectedCluster.scope_access[j]['role']
            } else {
              accRole = 'Admin - ' + SelectedCluster.access_type
            }
            SelectedScope = SelectedCluster.scope_access[j]
            Access = accRole
            break
          } else {
            accRole = 'Admin - No Access'
          }
        }
      }
    } else {
      if (
        SelectedCluster.scope_access.length === 0 &&
        accRole === '' &&
        SelectedCluster.access_type !== 'Custom'
      ) {
        accRole = 'Admin - No Access'
      } else {
        if (SelectedCluster.access_type === 'Custom' && SelectedCluster.scope_access.length === 0) {
          accRole = 'Admin - No Access'
        }
      }
    }
  }

  localStorage.setItem('UserAcc', Common.encryptData(accRole, true))
  const userPayload = {
    id: emailId,
    name: name,
    email: emailId,
    role: accRole,
    authorized: true,
    licenseType: Object.keys(SelectedCluster).length > 0 ? SelectedCluster.licenseType : '',
    clusterId: Object.keys(SelectedCluster).length > 0 ? SelectedCluster.clusterId : '',
    scope_id: Object.keys(SelectedScope).length > 0 ? SelectedScope.scope_id : '',
    selectedCluster: SelectedCluster,
    selectedScope: SelectedScope,
    AllAccessData: getAccData.data,
    eulaStatus: getAccData.data.data.EULA,
    otpStatus: success,
    otpInvalid: success.data.status === 'error' ? true : false,
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })
  yield put({
    type: 'user/SET_STATE',
    payload: userPayload,
  })

  yield put({
    type: 'accdetails/SET_ACCDETAILS',
    payload: {
      selectedCluster: SelectedCluster,
      selectedScope: SelectedScope,
    },
  })

  localStorage.setItem('userPayload', Common.encryptData(userPayload))
  localStorage.setItem('IsInvalid', false)
  localStorage.setItem('SSID', success.data.data.SSID)
  localStorage.setItem('loginStatus', 'success')
  localStorage.setItem('email', Common.encryptData(payload.emailId, true))
  localStorage.setItem('name', Common.encryptData(name, true))
  localStorage.setItem('notifMsg', JSON.stringify([]))
  localStorage.setItem('app.settings.theme', 'dark')
  localStorage.setItem('app.settings.menuColor', 'dark')
  localStorage.setItem('app.settings.isMenuCollapsed', true)
  var historyURLpath = localStorage.getItem('historyURL')
  var menuData = yield call(getMenuData)
  var path = ''
  if (Object.keys(SelectedCluster).length > 0 || Object.keys(SelectedScope).length > 0) {
    var scopeID = Object.keys(SelectedScope).length > 0 ? '/' + SelectedScope.scope_id : ''
    if (accRole !== 'User - No Access') {
      if (accRole === 'Admin - No Access') {
        if (
          historyURLpath &&
          historyURLpath !== 'null' &&
          historyURLpath !== null &&
          historyURLpath !== 'undefined' &&
          historyURLpath !== '/auth/login/verify-otp'
        ) {
          path = historyURLpath
        } else {
          if (accRole === 'User - Viewer' || accRole === 'Admin - Viewer') {
            path = '/' + SelectedCluster.clusterId + scopeID + '/dashboard'
          } else {
            path = '/' + SelectedCluster.clusterId + scopeID + '/admin/components'
          }
        }
      } else {
        if (
          historyURLpath &&
          historyURLpath !== 'null' &&
          historyURLpath !== null &&
          historyURLpath !== 'undefined' &&
          historyURLpath !== '/auth/login/verify-otp'
        ) {
          path = historyURLpath
        } else {
          if (accClusterCount > 1) {
            if (accRole === 'User - Viewer' || accRole === 'Admin - Viewer') {
              path = '/' + SelectedCluster.clusterId + scopeID + '/dashboard'
            } else {
              path = '/' + SelectedCluster.clusterId + scopeID + '/home/'
            }
          } else {
            if (accRole === 'User - Viewer' || accRole === 'Admin - Viewer') {
              path = '/' + SelectedCluster.clusterId + scopeID + '/dashboard'
            } else if (SelectedCluster.scope_access.length > 1) {
              path = '/' + SelectedCluster.clusterId + scopeID + '/home/scope/' + SelectedCluster.clusterId
            } else {
              path = '/' + SelectedCluster.clusterId + scopeID + '/home' + scopeID + '/' + SelectedCluster.clusterId
              // var path = '/' + SelectedCluster.clusterId + scopeID + '/workbook/new'
            }
          }
        }
      }
      for (var i = 0; i < menuData.length; i++) {
        if (menuData[i]['url']) {
          menuData[i]['url'] = menuData[i]['url'].replace(
            '//',
            '/' + SelectedCluster.clusterId + scopeID,
          )
        }
        if (menuData[i]['children']) {
          if (menuData[i]['title'] === 'System' && menuData[i]['key'] === 'system') {
            if (
              accRole !== 'Admin - SecAdmin Security Engineer' &&
              accRole !== 'User - SecAdmin Security Engineer' &&
              accRole !== 'Admin - Security Engineer'
            ) {
              var sysMenu = menuData[i]['children']
              for (var j = 0; j < sysMenu.length; j++) {
                if (sysMenu[j]['title'] === 'Utilization' && sysMenu[j]['key'] === 'utilization') {
                  sysMenu.splice(j, 1)
                }
                if (sysMenu[j]['title'] === 'Administration' && sysMenu[j]['key'] === 'secadmin') {
                  sysMenu.splice(j, 1)
                }
              }
            }
          }
          for (var j = 0; j < menuData[i]['children'].length; j++) {
            if (menuData[i]['children'][j]['url'].length > 0) {
              menuData[i]['children'][j]['url'] = menuData[i]['children'][j]['url'].replace(
                '//',
                '/' + SelectedCluster.clusterId + scopeID,
              )
            }
          }
        }
      }
    } else {
      path = '/no-access/auth/no-access'
      menuData = []
    }
  } else {
    path = '/no-access/auth/no-access'
    menuData = []
  }

  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuData,
    },
  })
  if (historyURLpath !== null) {
    localStorage.removeItem('historyURL')
    yield history.replace(path)
  } else {
    localStorage.removeItem('historyURL')
    yield history.push(path)
  }
}

export function* LOGIN({ payload }) {
  // const { emailId } = payload
  // const provider = reduxStore.getState().settings.authProvider
  const login = Auth_login
  // const login = provider === 'dnif' ? Auth_login : FB_login
  var success = ''
  // var Access = 'No Access'
  try {
    success = yield call(login, payload)
    if (
      success &&
      success.data.data.mfa_flag === 'disabled' &&
      success.data.data.SSID &&
      success.data.data.access.length > 0
    ) {
      yield AfterLoginPrequisites(payload, success)
    } else if (success && success.data.data.mfa_flag === 'enabled') {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
        },
      })
      var path = '/auth/login/verify-otp'
      history.push({ pathname: path, state: success.data.data })
    } else {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  } catch (error) {
    Common.showNotifications(
      'error',
      error.response ? error.response.data.message : 'Login verification failed',
    )
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* VERIFY_OTP({ payload }) {
  const verify_otp = Verify_OTP
  var success = ''
  var Access = 'No Access'
  try {
    success = yield call(verify_otp, payload)
    if (success && success.data.data.SSID && success.data.data.access.length > 0) {
      yield AfterLoginPrequisites(payload, success)
    } else {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
          otpStatus: success,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
        otpInvalid: error.response.data.status === 'error' ? true : false,
      },
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  const currentAccount = Auth_currentAccount
  // const currentAccount = provider === 'dnif' ? Auth_currentAccount : FB_currentAccount
  const history = createHashHistory()
  if (history.location.pathname.indexOf('/auth/') === -1 && history.location.pathname !== '/') {
    var historyURLmain = history.location.pathname + history.location.search
    localStorage.setItem('historyURL', historyURLmain)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(currentAccount)
  if (response) { }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT({ payload }) {
  // const logout = provider === 'dnif' ? Auth_logout : FB_logout
  const logout = Auth_logout
  const invalidate = Auth_invalidate
  // var ssid = localStorage.getItem('SSID')
  // var SelectedCluster = Common.getSelectedCluster()
  var obj = {
    SSID: payload.ssid,
    clusterId: payload.clusterId,
  }
  // var obj = { SSID: payload.ssid, clusterId: SelectedCluster.clusterId }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: 'User - Viewer',
      email: '',
      avatar: '',
      licenseType: '',
      authorized: false,
      loading: false,
      eulaStatus: true,
    },
  })
  localStorage.setItem('SSID', '')
  localStorage.setItem('email', '')
  localStorage.removeItem('payload')
  var invalid = yield call(invalidate, obj)
  var success = yield call(logout, obj)
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.VERIFY_OTP, VERIFY_OTP),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
